import ST from 'stjs';
export function applyTemplate(data, template) {
    if (!template) {
        return data;
    }
    return ST.select(data)
        .transformWith(template)
        .root();
}
